export default (params) => ({
  trigger: {
    name: 'content_blocks.article_list.show',
    params: params,
  },
  config: {
    schema: {
      title: {
        type: 'string',
      },
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'one_list',
          'two_lists',
          'three_lists',
          'one_list_personalized',
          'two_lists_personalized',
          'three_lists_personalized',
        ],
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'show_content_block',
    },
    nonInt: true,
  },
});
